import { GlobalIcon, Typography } from "get-life-storybook-ts";

interface WithdrawalRightNoticeProps {
  translate: (key: string) => string;
}

const WithdrawalRightNotice = ({ translate }: WithdrawalRightNoticeProps) => {
  return (
    <div className="max-w-[960px] mx-auto mb-6 px-4 py-4 bg-emerald-50 border border-emerald-200 rounded-lg flex items-start gap-3">
      <GlobalIcon iconName="RotateIcon" size="S" color="#047857" />
      <div className="flex flex-col">
        <Typography
          variant="Body"
          weight="700"
          text={translate("compliance.upsell.it.withdrawal.title")}
          className="text-emerald-900 mb-1"
        />
        <Typography
          variant="BodySmall"
          weight="400"
          text={translate("compliance.upsell.it.withdrawal.body")}
          className="text-emerald-800"
        />
      </div>
    </div>
  );
};

export default WithdrawalRightNotice;
